import { useUser, useConfig } from '@/store';
import axios, { AxiosHeaders, HttpStatusCode, isAxiosError } from 'axios';
import { useViewStore } from '@/store/ViewStore';
import _ from 'lodash';

export async function bootApp() {
  await useConfig().loadConfiguration();
  setupApi();
}

function setupApi() {
  const userStore = useUser();
  const viewStore = useViewStore();

  // interceptors
  // be aware these interceptors are not used by the axios.create factory fn

  // auth header interceptor
  axios.interceptors.request.use(
    rqstConfig => {
      const headers = (rqstConfig.headers ?? {}) as AxiosHeaders;
      const authHeaderKey = 'Authorization';
      const token = userStore.token;

      if (token && !headers.has(authHeaderKey)) {
        headers.set(authHeaderKey, token);
      }

      headers.set('Access-Control-Allow-Origin', '*.drivalia.cz');

      //headers.set('x-view-store', viewStore.currentView);

      rqstConfig.headers = headers;

      return rqstConfig;
    },

    error => {
      return Promise.reject(error);
    }
  );

  // intercept 401 responses to try to refresh the token
  axios.interceptors.response.use(undefined, async (err): Promise<unknown> => {
    if (
      isAxiosError(err) &&
      err.response?.status === HttpStatusCode.Unauthorized
    ) {
      await userStore.silentLogin();
    } else {
      return Promise.reject(err);
    }
  });
}
